import { useContext } from "react";
import { OrderHistoryFilterContext } from "../context/OrderHistoryFilterContext";
import OrderHistoryFilterContextType from "../interfaces/context/OrderHistoryContextType";

export const useOrderHistoryFilters = (): OrderHistoryFilterContextType => {
  const context = useContext(OrderHistoryFilterContext);

  if (context === undefined) {
    throw new Error('useOrderHistoryFilters must be used within a FilterProvider');
  }

  return context;
};
